export const getters = {
    access_token: (state: any) => state.user.access_token,
    userInfo: (state: any) => state.user.info,
    roles: (state: any) => state.user.roles,
    menus: (state: any) => state.user.menus,
    permissions: (state: any) => state.user.permissions
}